<div class="flex flex-col h-full justify-between">
  <app-header title="Select a user">
    <button
      additional-slot
      id="close-modal-button"
      class="btn-primary m-0 flex items-center justify-center w-min p-1"
      (click)="closeModal()"
    >
      <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
    </button>
  </app-header>
  @if ((loadingState$ | async) == 'loading') {
    <app-loader [loadingState]="'loading'" [inline]="true" class="w-full h-full"> </app-loader>
  }

  <form [formGroup]="userSearchFormGroup" class="flex flex-row justify-center items-center">
    <div
      id="user-select-search-container"
      class="flex w-full items-center justify-between border-2 border-grey-mid border-solid rounded-full cursor-text overflow-hidden m-3 sticky top-3 focus-within:border-primary"
    >
      <input
        id="user-select-search-input"
        #searchInput
        class="h-min border-none hover:border-none bg-transparent px-4 py-1 text-lg"
        type="text"
        placeholder="Search"
        autofocus
        autocomplete="off"
        minlength="3"
        formControlName="userSearchInput"
        (keyup)="filterGroupUsers()"
      />
      <ion-icon class="text-lg p-2 text-secondary" name="search-outline"></ion-icon>
    </div>
  </form>

  <div class="flex pb-6 h-full overflow-auto scroll-shadow">
    @if ((groupUsers$ | async).length > 0) {
      <div class="w-full">
        @for (user of groupUsers$ | async; track user.id) {
          <app-user-selector-item
            class="block cursor-pointer border-b border-b-grey-concrete hover:bg-grey-concrete/40"
            [user]="user"
            (selectedUser)="selectedUser($event)"
          >
          </app-user-selector-item>
        }
      </div>
    }
    @if ((groupUsers$ | async).length === 0 && (loadingState$ | async) !== 'loading') {
      <div class="w-full text-center italic opacity-60 pt-6">No users found.</div>
    }
  </div>
  @if (showRemoveOwner) {
    <div
      class="flex shrink-0 items-center justify-end gap-2 border-t border-grey-concrete bg-white p-3 text-sm text-grey-blue shadow-md"
    >
      <button class="btn-danger-secondary btn-xs text-sm" type="button" (click)="removeOwner()">Remove Owner</button>
    </div>
  }
</div>
